<template>
	<b-container class="show-document">
		<div class="doc-body" style="text-align: center; align-items: center">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
				</div>
				<div class="pull-right">
					<b-button variant="outline-dark" class="mr-2" @click="print">
						<i class="fa fa-print"></i> Печать {{ $t('incomes.create.prices') }}
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div class="row">
				<div class="printElement col-4" v-for="(item, index) in items.MAGAZIN" :key="`price-generate-${index}`">
					<p class="text-center" style="padding-top: 20px"><b>{{item.barcode}}</b></p>
					<p class="text-center info">{{ item.name }}</p>
					<p><b class="price" > {{ item.priceUzs }}</b></p>
					<barcode :value="item.barcodeSubString ? item.barcodeSubString : item.barcodeString" :options="{height: '25px', displayValue: false}" tag="svg"></barcode>
					<p class="barcode"><b>{{ item.barcodeSubString ? item.barcodeSubString : item.barcodeString }}</b></p>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: "Prices",
	data() {
		return {
		}
	},
	computed: {
		...mapState('warehouse', {'items': 'filteredItems'})
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			window.print();
		}
	},
	created() {
		if (this.items.MAGAZIN) {
			if (this.items.MAGAZIN.length > 0) {
			} else {
				this.$router.back();
			}
		} else {
			this.$router.back();
		}
	}
}
</script>

<style scoped>
body {
	background-color: white !important;
}

.printElement {
	padding-left: 10px !important;
	text-align: center;
	/*page-break-before: always;*/
	/*page-break-after: always;*/
	/*page-break-inside: avoid;*/
	/*word-break: break-all;*/
	color: #000;
	width: 100mm !important;
	height: 50mm !important;
	border: 1px dashed #868686;
	background-color: white;
}
.printElement svg {
	width: 100% !important;
	margin-top: -3px;
}

.printElement p {
	font-family: "Arial Black", Gadget, sans-serif;
	text-align: center;
	color: #000000 !important;
	font-weight: bold;
	font-size: 15px !important;
	margin: 0;
	line-height: 1;
}

.specialBarcode {
	font-size: 17px;
	padding-left: 40%;
}

.printElement .price {
	margin-top: -5px !important;
	font-size: 30px !important;
}
.printElement p.barcode {
	font-size: 10px;
}

@media print {
	/*html, body {*/
	/*	margin: 0 !important;*/
	/*	text-align: center;*/
	/*	padding: 0 !important;*/
	/*}*/
	/** {*/
	/*	box-sizing: border-box;*/
	/*	padding: 0;*/
	/*	margin: 0;*/
	/*}*/
	/*@page { size: landscape; }*/
	.hidden-print {
		display: none;
	}
	/*.printElement {*/
	/*	border: none;*/
	/*}*/

}
</style>
